import {Hero} from '../types'

export const GetHeroImage = (hero:Hero) => {
    const heroImagePath = 'heroes/meleeHeroesImages';
    const context = require(`../${heroImagePath}/${hero.Image}`);
    return context;
}